define('common/async',['jquery'], function ($) {

    return {
        defer: function(action) {
            return $.Deferred(action);
        },
        wait: function(timeoutInMilliseconds) {
            return this.defer(function(dfd) {
                setTimeout(dfd.resolve, timeoutInMilliseconds);
            }).promise();
        }
    };
});

